import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=07eab37e&"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js&"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports